module.exports = __webpack_public_path__ + "static/img/n_1_8.e7562cb7.png";